module.exports = "/images/vendor/flag-icon-css/flags/1x1/pk.svg?b67f80e0c74ad587ee42bd6c2a811946";